import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations/index.js'
import state from './state/index.js'
import getters from './getter/index.js'
import actions from './actions/index.js'

Vue.use(Vuex)
const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
export default store
